"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTaxRateMasterSchema = exports.createTaxRateMasterSchema = exports.taxRateMasterShape = void 0;
const zod_1 = require("zod");
/** Enterprise Architecture Handbook v1.0 (OP Billing Administration, Module 3 — Tax/GST Configuration). */
exports.taxRateMasterShape = {
    taxTypeId: zod_1.z.string().uuid().optional(),
    code: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().min(1).max(255),
    hsnSacCode: zod_1.z.string().min(1).max(10).optional(),
    gstPercent: zod_1.z.number().min(0).max(100),
    cessPercent: zod_1.z.number().min(0).max(100).optional(),
    effectiveFrom: zod_1.z.coerce.date(),
    effectiveTo: zod_1.z.coerce.date().optional(),
};
exports.createTaxRateMasterSchema = zod_1.z.object(exports.taxRateMasterShape);
exports.updateTaxRateMasterSchema = zod_1.z.object(exports.taxRateMasterShape).partial();
//# sourceMappingURL=tax-rate-master.schema.js.map